export default {
  functionKey: "TRONQUE",
  title: "TRONQUE",
  group: "Calcul",
  origin: [],
  target: [],
  arguments: [],
  maxArguments: 1,
  expectedArguments: [
    { name: "(Optionnel) Nombre de décimales", argumentKey: "Decimals", single: true, initialValue: "0" }
  ],
  description: "Tronque un nombre sans arrondir. (Ex: TRONQUE(4.99) -> 4, TRONQUE(4.567, 2) -> 4.56)",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const decimals = (args[0] && args[0] !== "''") ? args[0] : "0";
    const jsCode = `${destination} = Math.trunc(${origin} * Math.pow(10, ${decimals})) / Math.pow(10, ${decimals});`;
    const safeCode = `
    if (!isNaN(parseFloat(${origin}))) {
      ${jsCode}
    } else {
      ${destination} = '';
    }`;
    return { displayCode: jsCode, safeCode };
  }
}
